// extracted by mini-css-extract-plugin
export var numpadContainer = "_qa-1";
export var phoneButton = "_qa-0";